import httpClient from "api/httpClient";
import { PaginatedResponse, PaginationParams } from "models/Pagination";
import {
  ReportJobPostEntity,
  ReportStatus,
  ReportUserEntity,
  UserBlockEntity,
  JobPostBlockEntity,
} from "models/Moderation";

const getUserReports = (params: PaginationParams) =>
  httpClient.get<PaginatedResponse<ReportUserEntity>>("admin/reports/user", {
    params,
  });

const getJobPostReports = (params: PaginationParams) =>
  httpClient.get<PaginatedResponse<ReportJobPostEntity>>(
    "admin/reports/job-post",
    { params }
  );

const updateUserReport = (id: number, status: ReportStatus) =>
  httpClient.put<ReportUserEntity>(`admin/reports/user/${id}`, { status });

const updateJobPostReport = (id: number, status: ReportStatus) =>
  httpClient.put<ReportJobPostEntity>(`admin/reports/job-post/${id}`, {
    status,
  });

const getUserBlocks = (params: PaginationParams) =>
  httpClient.get<PaginatedResponse<UserBlockEntity>>("admin/blocks/user", {
    params,
  });

const getJobPostBlocks = (params: PaginationParams) =>
  httpClient.get<PaginatedResponse<JobPostBlockEntity>>(
    "admin/blocks/job-post",
    { params }
  );

const removeUserBlock = (id: number) =>
  httpClient.delete(`admin/blocks/user/${id}`);

const removeJobPostBlock = (id: number) =>
  httpClient.delete(`admin/blocks/job-post/${id}`);

export default {
  getUserReports,
  getJobPostReports,
  updateUserReport,
  updateJobPostReport,
  getUserBlocks,
  getJobPostBlocks,
  removeUserBlock,
  removeJobPostBlock,
};
